// extracted by mini-css-extract-plugin
module.exports = {"container":"Brands-module--container--2lZwj"};